import dayjs from 'dayjs'

/** 筛选日期统一为 YYYY-MM-DD（避免 Date / ISO 带时分秒） */
export function toFilterDateOnly (v) {
  if (v == null || v === '') return ''
  if (typeof v === 'string') {
    const t = v.trim()
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t
    const m = t.match(/^(\d{4}-\d{2}-\d{2})/)
    if (m) return m[1]
  }
  const d = dayjs(v)
  return d.isValid() ? d.format('YYYY-MM-DD') : ''
}

/** startTime 为更早一天，endTime 为更晚一天 */
export function orderFilterDateRange (startTime, endTime) {
  const s = startTime ? toFilterDateOnly(startTime) : ''
  const e = endTime ? toFilterDateOnly(endTime) : ''
  if (!s || !e) return { startTime: s, endTime: e }
  if (dayjs(s).isAfter(dayjs(e), 'day')) {
    return { startTime: e, endTime: s }
  }
  return { startTime: s, endTime: e }
}
